import blogDigitalMarketing from "Assets/blog/blog-digital-marketing.png";
import blogSalesManagementSystem from "Assets/blog/blog-sales-management-system.png";
import blogHubspotCrm from "Assets/blog/blog-hubspot-crm.png";

const websitePrefix = "Hububble Marketing Plan Generator";

const formPageSlugs = [
  "name",
  "name-success",
  "company-name",
  "company-size",
  "marketing-channel",
  "nurturing-approach",
  "marketing-staffing",
  "marketing-capabilities",
  "top-goals",
  "marketing-pain-points",
  "privacy-send",
];

const getPageNumber = (slug) => formPageSlugs.indexOf(slug) + 1;

const getPageSlug = (pageNumber) =>
  formPageSlugs[pageNumber - 1] || formPageSlugs[0];

const companySizeData = [
  {
    label: "1 - 5",
    value: "1-5",
  },
  {
    label: "6 - 25",
    value: "5-25",
  },
  {
    label: "26 - 50",
    value: "25-50",
  },
  {
    label: "51 - 200",
    value: "51-200",
  },
  {
    label: "200+",
    value: "200+",
  },
];

const painPointsData = [
  {
    label: "找不到潛在客戶",
    helpTextContent:
      "尋找潛在客戶時，你需要做的第一件事就是了解你的目標角色 Persona 人物誌。Hububble 可以協助您建立內容行銷策略尋找合格的潛在客戶，透過部落格文章、電子書、影片、線上研討會…等有價值的實用內容都是吸引受眾、創造潛在客戶。如果客戶主動搜尋到您提供的內容，就會因此對您的產品/服務感興趣。此外，透過自動化行銷工具的輔助，也可以自動化執行潛在客戶開發與銷售培育。",
  },
  {
    label: "低轉換率",
    helpTextContent:
      "提高轉化率，幫助企業利用現有流量吸引更多客戶，要提高轉換率的第一步，了解您的客戶行為軌跡。透過 Hububble 提供的 CRO 計畫，進行如何網站審核優化、確定改進轉化漏斗的觸點、了解您網站上的用戶行為軌跡以及 A/B 測試和數據驅動來優化您的轉換率。",
  },
  {
    label: "自然搜尋量低",
    helpTextContent:
      "網站自然流量都是從關鍵字來的，而該關鍵字流量的多寡，則取決於關鍵字搜尋量跟點閱率，想要增加自然搜尋量，第一步要先制定有商業價值與搜尋量的關鍵字策略。Hububble 擅長經營自然流量，24 個月 0-130K 的自然流量增長，歡迎與我們聊聊。",
  },
  {
    label: "沒有工程團隊",
    helpTextContent:
      "不論您有任何網站建置、軟體串接開發上的疑難雜症都歡迎直接與 Hububble 聯繫，我們豐富的開發經驗能幫您解決遇到的問題。",
  },
  {
    label: "行銷活動成效不好",
    helpTextContent:
      "Hububble 幫助客戶以數據分析行銷成效，在活動中不斷修正與優化，理解數據之間的前因後果，找出脈絡才能幫您帶來令人滿意的行銷成效，過程中完整收集客戶資料與行為軌跡，持續再行銷。",
  },
  {
    label: "付費廣告成效不佳",
    helpTextContent:
      "若您沒有擬定任何策略與計劃，也沒有受眾輪廓、完整的受眾名單這樣的廣告肯定成效不佳。Hububble 對不同廣告渠道有不同的策略，幫助您有深入了解您的受眾人物誌，以客戶行為分眾再行銷精準投放。",
  },
  {
    label: "客戶流失率很高",
    helpTextContent:
      "Hububble 建議您使用 CRM 管理您的客戶紀錄，便於企業對客戶進行管理、自動化維繫客戶關係，尤其是可以加深企業與已有老客戶之間的互動交流，降低老客戶的流失率。",
  },
  {
    label: "無法提供個人化訊息",
    helpTextContent:
      "Hububble 建議您使用 CRM 工具來收集客戶訊息，幫助您辨識顧客的需求，更加情境化地與顧客溝通，在他們需要之時，釋出推銷或協助的訊息，優化客戶體驗",
  },
  {
    label: "找不到適合的數位工具",
    helpTextContent:
      "歡迎您與 Hububble 聊聊！我們以 Inbound Marketing 的思維專注在 SEO 與內容策略上加上 HubSpot 工具的輔助，至今我們已經成功協助數十家上市公司與中小型企業協助數位轉型，我們成為網站開發、HubSpot 導入、企業數位轉型、集客式行銷、SEO 優化、網路行銷策略經營的顧問角色。",
  },
  {
    label: "無法執行分眾行銷",
    helpTextContent:
      "Hububble 幫助您精準做出分眾行銷，不僅培養出忠實客群，更能有效提高轉換率。想要在業界脫穎而出，投放大量廣告撒網補魚已經無效，而是必須鎖定目標客群，採用「分眾行銷」手法，才能真正達到行銷目的",
  },
];

const priorityMetricsData = [
  {
    label: "加快成交速度",
    metricLabel: "轉換率 Contact to Customer Rate",
    metricUnit: "%",
  },

  {
    label: "搜尋引擎優化 (SEO)",
    metricLabel: "自然流量",
    metricUnit: null,
  },

  {
    label: "降低獲客成本",
    metricLabel: "平均每位獲客成本",
    metricUnit: "dollars",
  },

  {
    label: "了解你的用戶輪廓",
    metricLabel: "每位客戶資料量",
    metricUnit: null,
  },
  {
    label: "增加營收",
    metricLabel: "營收金額",
    metricUnit: "$",
  },
  {
    label: "增加客戶 NPS",
    metricLabel: "NPS",
    metricUnit: null,
  },

  {
    label: "提升業務銷售的工作效率",
    metricLabel: "任務完成度",
    metricUnit: "%",
  },

  {
    label: "提高點擊率",
    metricLabel: "點擊率",
    metricUnit: "%",
  },

  {
    label: "提高轉換率",
    metricLabel: "轉換率",
    metricUnit: "%",
  },

  {
    label: "增加潛在客戶",
    metricLabel: "潛在客戶數量",
    metricUnit: "$",
  },
];

const priorityMetricsPeriods = [
  {
    label: "每天",
    value: "daily",
  },
  {
    label: "每週",
    value: "weekly",
  },
  {
    label: "每月",
    value: "monthly",
  },
  {
    label: "每季",
    value: "quarterly",
  },
  {
    label: "每年",
    value: "yearly",
  },
];

const secondaryGoalsData = [
  {
    label: "加快成交速度",
  },
  {
    label: "搜尋引擎優化 SEO",
  },
  {
    label: "降低獲客成本",
  },
  {
    label: "了解你的用戶輪廓",
  },
  {
    label: "增加營收",
  },
  {
    label: "增加客戶NPS",
  },
  {
    label: "提升業務銷售的工作效率",
  },
  {
    label: "提高點擊率",
  },
  {
    label: "提高轉換率",
  },
  {
    label: "增加潛在客戶",
  },
];

const marketingChannelData = [
  { label: "企業官方網站", value: "website", score: 2 },
  {
    label: "社群平台（FB / IG / Threads / TikTok…）",
    value: "social_media",
    score: 1,
  },
  { label: "YouTube", value: "youtube", score: 1 },
  {
    label: "數位廣告（Google / Meta / LinkedIn…）",
    value: "paid_ads",
    score: 2,
  },
  { label: "LINE 官方帳號", value: "line_oa", score: 2 },
  { label: "EDM 電子報", value: "newsletter", score: 3 },
  { label: "實體活動（參展、擺攤）", value: "offline_events", score: 2 },
  { label: "線上研討會（講座、工作坊）", value: "webinars", score: 2 },
  { label: "異業合作、品牌聯名", value: "partnerships", score: 2 },
  { label: "其他", value: "other", score: 0, hasTextField: true },
];

const nurturingApproachData = [
  {
    label: "主要靠**人工跟進**，透過電話、私訊或寄信維持關係熱度。",
    value: "manual_follow_up",
    level: 0,
    displayLabel: "人工跟進",
  },
  {
    label:
      "會使用 Social CRM、CDP 或 CRM 工具管理名單，但**尚未建立**固定培育流程。",
    value: "tools_no_nurture",
    level: 1,
    displayLabel: "工具輔助",
  },
  {
    label:
      "已有 1-2 條固定的**自動化跟進流程**（例如新名單歡迎信、活動後跟進）",
    value: "basic_automation",
    level: 2,
    displayLabel: "自動跟進流程",
  },
  {
    label:
      "有 80% 以上的客戶維繫、培育流程是使用自動化，並有完整的**分眾培育機制**（多條流程＋定期優化）",
    value: "advanced_automation",
    level: 3,
    displayLabel: "分眾培育機制",
  },
];

const marketingStaffingData = [
  { label: "內部有**專職行銷**人員", value: "dedicated_in_house_marketing" },
  { label: "內部有人員**兼任行銷**", value: "shared_role_marketing" },
  { label: "老闆／主管**自行處理**", value: "owner_led_marketing" },
  { label: "主要由外部廠商／**顧問協助**", value: "outsourced_marketing" },
  { label: "目前**尚未配置**行銷相關人力", value: "no_marketing_staff" },
];

const marketingCapabilitiesData = [
  {
    label: "找得到數據：\n計算每筆名單或訂單的取得成本（CPL/CAC/ROAS）。",
    value: "measurable_cost_metrics",
    score: 25,
  },
  {
    label:
      "看得到客戶的互動紀錄：\n能追蹤顧客從第一次互動到成交的主要路徑（含 CRM 或追蹤工具）。",
    value: "trackable_customer_journey",
    score: 25,
  },
  {
    label:
      "分眾客製化互動：\n能依受眾興趣或行為，做名單分類，並依據名單類型，傳送個人化訊息。",
    value: "segmented_personalization",
    score: 20,
  },
  {
    label:
      "自動化運作：\n系統會自動發送跟進提醒（自動化信件、生日禮、優惠提醒等）。",
    value: "automated_follow_up",
    score: 15,
  },
  {
    label:
      "跨團隊訂定目標：\n定期產出數據報表檢視成效，並與業務 / 客服/ 產品開發/ 採購等等部門，共同對齊目標與成效。",
    value: "cross_team_alignment",
    score: 10,
  },
  {
    label: "行銷內容持續優化：\n定期做 A/B 測試，並根據結果滾動式調整作法。",
    value: "continuous_optimization",
    score: 5,
  },
];

const topGoalsData = [
  { label: "增加營收", value: "revenue_growth" },
  { label: "提高轉換率", value: "conversion_rate_improvement" },
  { label: "增加潛在客戶數", value: "lead_growth" },
  { label: "提升客戶滿意度", value: "customer_satisfaction_improvement" },
  { label: "降低獲客成本", value: "acquisition_cost_reduction" },
  { label: "搜尋引擎優化（SEO）", value: "seo" },
  { label: "提升業務銷售效率", value: "sales_efficiency_improvement" },
  { label: "加快成交速度", value: "sales_cycle_acceleration" },
  { label: "了解用戶輪廓與需求", value: "customer_insights" },
];

const marketingPainPointsData = [
  {
    label: "【數據與技術】\n數據追蹤不準且缺乏自動化工具，導致成效難以量化。",
    value: "measurement_difficulty",
  },
  {
    label: "【策略與內容】\n缺乏長期佈局且內容產出緩慢，難以跟上市場變化。",
    value: "content_strategy_gap",
  },
  {
    label: "【資源與流量】\n獲客成本過高且流量遭遇天花板，新渠道切入困難。",
    value: "acquisition_growth_challenges",
  },
  {
    label: "【組織與執行】\n團隊人手不足且溝通成本高，導致執行與目標脫節。",
    value: "team_execution_challenges",
  },
];

const q4ScoreMapping = [
  { min: 0, max: 3, display: "🚀 單點起步型" },
  { min: 4, max: 7, display: "🔀 多線嘗試型" },
  { min: 8, max: Infinity, display: "🌐 多管道布局型" },
];

const q7MaturityMapping = [
  {
    min: 0,
    max: 29,
    title: "起步期",
    subtitle: "開始行銷行動，尚未有固定內容更新",
    description:
      "你已開始嘗試行銷行動，但目前仍屬於探索與試水溫的階段。\n在這個階段，團隊往往正在判斷哪些行動值得持續投入。",
  },
  {
    min: 30,
    max: 54,
    title: "成長期",
    subtitle: "有固定內容更新、基本數據追蹤",
    description:
      "你已建立基本的行銷節奏，也開始關注數據與成效。\n在這個階段，團隊通常仍在摸索如何從數據中做出更明確的判斷。",
  },
  {
    min: 55,
    max: 79,
    title: "進階期",
    subtitle: "已導入AI、自動化與部分個人化行銷應用",
    description:
      "你已開始運用 AI、自動化或個人化工具，行銷系統逐漸成形。\n在這個階段，團隊大多正在評估哪些流程真正帶來價值。",
  },
  {
    min: 80,
    max: 100,
    title: "成熟期",
    subtitle: "多管道行銷、自動化、行銷＋銷售整合",
    description:
      "你的行銷已具備完整架構，並且與銷售流程有所整合。\n在這個階段，團隊會持續檢視哪些投入值得放大，哪些環節其實可以被簡化。",
  },
];

const pageData = [
  {
    slug: "name",
    pageTitle: "Name Input",
    backgroundStyle: "default",
  },
  {
    slug: "name-success",
    pageTitle: "Welcome",
    isNotIndexed: true,
    backgroundStyle: "fullwidth",
  },
  {
    slug: "company-name",
    pageTitle: "首先，你的公司名稱及產業？",
    backgroundStyle: "default",
  },
  {
    slug: "company-size",
    pageTitle: "Company Size",
    backgroundStyle: "default",
  },
  {
    slug: "marketing-channel",
    pageTitle: "你們目前主要使用哪些行銷管道？",
    backgroundStyle: "default",
  },
  {
    slug: "nurturing-approach",
    pageTitle: "得到客戶名單後，\n你們通常如何維繫客戶關係？",
    backgroundStyle: "default",
  },
  {
    slug: "marketing-staffing",
    pageTitle: "目前行銷工作主要由誰負責執行？",
    backgroundStyle: "default",
  },
  {
    slug: "marketing-capabilities",
    pageTitle: "關於行銷**執行現況**，請選擇有符合的描述",
    backgroundStyle: "default",
  },
  {
    slug: "top-goals",
    pageTitle: "2026 年你最希望優先實現的 \n前三項行銷目標？",
    backgroundStyle: "default",
  },
  {
    slug: "marketing-pain-points",
    pageTitle: "目前在做行銷時，\n你覺得卡關的地方是哪些？",
    backgroundStyle: "default",
  },
  {
    slug: "privacy-send",
    pageTitle: "Privacy and Submit",
    backgroundStyle: "default",
  },
];

const suggestedBlogPostsData = [
  {
    label:
      "數位行銷（Digital Marketing ）在做什麼 ？網路行銷方法與案例分享【2026】",
    url: "https://www.hububble.co/blog/digital-marketing",
    featuredImage: {
      src: blogDigitalMarketing,
      alt: "數位行銷",
    },
  },
  {
    label: "銷售管理工具怎麼選？從 Excel、Notion 到 HubSpot 的實際比較",
    url: "https://www.hububble.co/blog/sales-management-system",
    featuredImage: {
      src: blogSalesManagementSystem,
      alt: "銷售管理工具",
    },
  },
  {
    label: "CRM 系統，企業必備的數位轉型工具 !",
    url: "https://www.hububble.co/blog/hubspot-crm",
    featuredImage: {
      src: blogHubspotCrm,
      alt: "CRM 系統",
    },
  },
];

const featuredPostData = {
  title: "HubSpot 中文版 同步上線！",
  description: "超完整中文教學指南，CRM 行銷、銷售、客服 HubSpot 功能完美組合",
  url: "https://www.hububble.co/blog/what-is-hubspot",
};

export {
  formPageSlugs,
  getPageNumber,
  getPageSlug,
  pageData,
  companySizeData,
  priorityMetricsData,
  priorityMetricsPeriods,
  painPointsData,
  secondaryGoalsData,
  marketingChannelData,
  nurturingApproachData,
  marketingStaffingData,
  marketingCapabilitiesData,
  topGoalsData,
  marketingPainPointsData,
  q4ScoreMapping,
  q7MaturityMapping,
  websitePrefix,
  suggestedBlogPostsData,
  featuredPostData,
};
